export default __webpack_public_path__ + "static/media/SCDream-Regular.64c9dc7c.otf";